import { FormInstance } from 'antd';
import { get, merge, set } from 'lodash';
import { CompanyTypeReq } from '~/types/CompanyType';
import { Handbook } from '~/types/Handbook';
import { KsaCompanyInformation } from '~/types/ksa/KsaCompanyInformation';
import { NameFn } from './buildNamePath';
import { Draft } from '~/types/Draft';

export const handleCompanyType =
  (form: FormInstance<any>, handbook: Handbook, n: NameFn) =>
  (changedValues: CompanyTypeReq, formValues: any) => {
    if (get(changedValues, n(['companyType', 'businessNature']))) {
      form.setFields([
        { name: n(['companyType', 'businessIndustry']), value: undefined },
        { name: n(['companyType', 'mcc']), value: undefined },
      ]);
    }
    if (get(changedValues, n(['companyType', 'businessIndustry']))) {
      const businessNature = formValues?.companyType?.businessNature;
      const businessIndustry = formValues?.companyType?.businessIndustry;

      if (handbook && businessNature && businessIndustry) {
        form.setFields([
          {
            name: n(['companyType', 'mcc']),
            value: getMcc(handbook)({ businessNature, businessIndustry }),
          },
        ]);
      }
    }
  };

const getMcc =
  (handbook: Handbook) =>
  ({ businessNature, businessIndustry }: { businessNature: string; businessIndustry: string }) => {
    return handbook
      .find((item) => item.key === 'businessNature')
      ?.values?.find((item) => item.apiValue === businessNature)
      ?.values?.find((item) => item.key.includes('businessLine'))
      ?.values?.find((item) => item.apiValue === businessIndustry)?.additionalParams?.mcc;
  };

const getAdditionalParams =
  (handbook: Handbook) =>
  ({ mccGroup, mccCode }: { mccGroup: string; mccCode: string }) => {
    return handbook
      .find((item) => item.key === 'mcc')
      ?.values?.find((item) => item.apiValue === mccGroup)
      ?.values?.find((item) => item.apiValue === mccCode)?.additionalParams;
  };

const setMccFieldsValues = (
  form: FormInstance<any>,
  formValues: Draft<'companyInformation'>,
  n: NameFn,
  fields: Array<string>,
  value: string | undefined
) => {
  fields.forEach((field: string) => {
    form.setFieldValue(n([field]), value);
    set(formValues, n([field]), value);
  });
};

export const handleMccGroupChangeKsa =
  (form: FormInstance<any>, handbook: Handbook | undefined, n: NameFn) =>
  (changedValues: KsaCompanyInformation, formValues: Draft<'companyInformation'>) => {
    if (get(changedValues, n(['mccGroup']))) {
      setMccFieldsValues(form, formValues, n, ['mccCode', 'terminalId', 'masterId'], '');
    }

    if (!get(changedValues, n(['mccCode']))) return;

    const mccGroup = formValues?.companyInformation?.mccGroup;
    const mccCode = formValues?.companyInformation?.mccCode;

    if (handbook && mccGroup && mccCode) {
      const additionalParams = getAdditionalParams(handbook)({ mccGroup, mccCode });
      const terminalId = additionalParams?.terminalId || '';
      const masterId = additionalParams?.masterId || '';
      form.setFields([
        {
          name: n(['terminalId']),
          value: terminalId,
        },
        {
          name: n(['masterId']),
          value: masterId,
        },
      ]);
      merge(formValues, {
        companyInformation: { terminalId, masterId },
      });
    }
  };
